import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import {
  AddCompany,
  Carbon1,
  Carbon2,
  Carbon3,
  Carbon4,
  CompanyList,
  DataLimits,
  DeveloperFeatures,
  DeveloperGenerateEmail,
  DeveloperModals,
  DeveloperVersion,
  EnergyConsumptionFuture,
  EnergyStatement,
  ExcelProcessor,
  Invoice,
  PartnersList,
  SettingsKeys,
  TenantList,
  UsersList,
  OrphanedUsers,
} from "@/pages";
import React from "react";
import { ModulesList, SubscriptionsList } from "@/components";
import { permissionsDeveloper } from "@/utils";
// import { CompanyLocations } from "@/pages";
// import { MeterList, MeterData } from "@/pages";
import { partnerRoutes } from "./partnerRoutes";
import { companyRoutes } from "./companyRoutes";
import { tenantRoutes } from "./tenantRoutes";
import { roleRoutes } from "./roleRoutes";
import { subscriptionRoutes } from "./subscriptionRoutes";

const parentPath = "developer";

/**
 * Route definitions for developer-only utility and administrative routes.
 * Includes company/tenant management, role configuration, subscriptions, and data utilities.
 */
export const developerRoutes: React.ReactElement<any>[] = [
  <Route
    key="energy"
    path="energy"
    element={
      <ProtectedRoute
        element={<EnergyConsumptionFuture />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="invoice"
    path="invoice"
    element={
      <ProtectedRoute element={<Invoice />} codes={permissionsDeveloper} />
    }
  />,

  <Route
    key="orphaned-users"
    path="orphaned-users"
    element={
      <ProtectedRoute
        element={<OrphanedUsers />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="modals"
    path="modals"
    element={
      <ProtectedRoute
        element={<DeveloperModals />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="partners"
    path="partners"
    element={
      <ProtectedRoute
        element={
          <PartnersList
            parentPath={parentPath}
            partnerFilter="all"
            showAdd
            showEdit
            showTenants
          />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  // <Route
  //   key="partners-users"
  //   path="partners/:partnerId/users"
  //   element={
  //     <ProtectedRoute
  //       element={<UsersList userFilter="partner" parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="partners-tenants"
  //   path="partners/:partnerId/tenants"
  //   element={
  //     <ProtectedRoute
  //       element={<TenantList parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  <Route
    key="users"
    path="users"
    element={
      <ProtectedRoute
        element={
          <UsersList showLogin userFilter="all" parentPath={parentPath} />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="companies"
    path="companies"
    element={
      <ProtectedRoute
        element={
          <CompanyList
            parentPath={parentPath}
            companyFilter="all"
            parentChildfilter="parent"
            showAdd
            showEdit
          />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="add-company"
    path="companies/add"
    element={
      <ProtectedRoute element={<AddCompany />} codes={permissionsDeveloper} />
    }
  />,

  <Route
    key="edit-company"
    path="companies/edit/:id"
    element={
      <ProtectedRoute element={<AddCompany />} codes={permissionsDeveloper} />
    }
  />,

  <Route
    key="edit-company-alt"
    path="companies/:id/edit"
    element={
      <ProtectedRoute element={<AddCompany />} codes={permissionsDeveloper} />
    }
  />,

  // <Route
  //   key="companies-child-companies"
  //   path="companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} showLocations />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="companies-child-companies-locations"
  //   path={`companies/:customerId/child-companies/:childCompanyId/${routesData.locations}`}
  //   element={
  //     <ProtectedRoute
  //       element={<CompanyLocations />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="companies-child-companies-locations-meters"
  //   path={`companies/:customerId/child-companies/:childCompanyId/${routesData.locationsMeters}`}
  //   element={
  //     <ProtectedRoute element={<MeterList />} codes={permissionsDeveloper} />
  //   }
  // />,

  // <Route
  //   key="companies-child-companies-locations-meters-data"
  //   path={`companies/:customerId/child-companies/:childCompanyId/${routesData.locationsMetersData}`}
  //   element={
  //     <ProtectedRoute element={<MeterData />} codes={permissionsDeveloper} />
  //   }
  // />,

  // <Route
  //   key="tenants-companies-child-companies"
  //   path="tenants/:tenantId/companies/:customerId/child-companies"
  //   element={
  //     <ProtectedRoute
  //       element={<SubsidiaryList parentPath={parentPath} showLocations />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="tenants-companies-child-companies-locations"
  //   path={`tenants/:tenantId/companies/:customerId/child-companies/:childCompanyId/${routesData.locations}`}
  //   element={
  //     <ProtectedRoute
  //       element={<CompanyLocations />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="tenants-companies-child-companies-locations-meters"
  //   path={`tenants/:tenantId/companies/:customerId/child-companies/:childCompanyId/${routesData.locationsMeters}`}
  //   element={
  //     <ProtectedRoute element={<MeterList />} codes={permissionsDeveloper} />
  //   }
  // />,

  // <Route
  //   key="tenants-companies-child-companies-locations-meters-data"
  //   path={`tenants/:tenantId/companies/:customerId/child-companies/:childCompanyId/${routesData.locationsMetersData}`}
  //   element={
  //     <ProtectedRoute element={<MeterData />} codes={permissionsDeveloper} />
  //   }
  // />,

  // <Route
  //   key="roles"
  //   path="roles"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <RolesListPage
  //           parentPath={parentPath}
  //           showAdd
  //           showEdit
  //           showDelete
  //           showPermissions
  //         />
  //       }
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="roles-permissions-key"
  //   path="roles/permissions/:key"
  //   element={
  //     <ProtectedRoute
  //       element={<ModulesList parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  <Route
    key="permissions"
    path="permissions"
    element={
      <ProtectedRoute
        element={
          <ModulesList parentPath={parentPath} showEdit showDelete showAdd />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="subscriptions"
    path="subscriptions"
    element={
      <ProtectedRoute
        element={
          <SubscriptionsList
            parentPath={parentPath}
            showAdd
            showEdit
            showDelete
            showFeatures
          />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="features"
    path="features"
    element={
      <ProtectedRoute
        element={<DeveloperFeatures />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="data-limits"
    path="data-limits"
    element={
      <ProtectedRoute
        element={
          <DataLimits showAdd showEdit showDelete parentPath={parentPath} />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="version"
    path="version"
    element={
      <ProtectedRoute
        element={<DeveloperVersion />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="settings-keys"
    path="settings-keys"
    element={
      <ProtectedRoute element={<SettingsKeys />} codes={permissionsDeveloper} />
    }
  />,

  <Route
    key="generate-email"
    path="generate-email"
    element={
      <ProtectedRoute
        element={<DeveloperGenerateEmail />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="excel"
    path="excel"
    element={
      <ProtectedRoute
        element={<ExcelProcessor />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="aggregation"
    path="aggregation"
    element={
      <ProtectedRoute
        element={<EnergyStatement />}
        codes={permissionsDeveloper}
      />
    }
  />,

  <Route
    key="tenants"
    path="tenants"
    element={
      <ProtectedRoute
        element={
          <TenantList showAdd showEdit showDelete parentPath={parentPath} />
        }
        codes={permissionsDeveloper}
      />
    }
  />,

  // <Route
  //   key="tenants-users"
  //   path="tenants/:tenantId/users"
  //   element={
  //     <ProtectedRoute
  //       element={<UsersList userFilter="tenant" parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="tenants-companies"
  //   path="tenants/:tenantId/companies"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <CompanyList
  //           companyFilter="tenant"
  //           parentPath={parentPath}
  //           parentChildfilter="all"
  //         />
  //       }
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="documents"
  //   path="documents"
  //   element={
  //     <ProtectedRoute
  //       element={
  //         <Documents parentPath={parentPath} showAdd showEdit showDelete />
  //       }
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="documents-add"
  //   path="documents/add"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  // <Route
  //   key="documents-view"
  //   path="documents/view/:id"
  //   element={
  //     <ProtectedRoute element={<DocumentView />} codes={permissionsDeveloper} />
  //   }
  // />,

  // <Route
  //   key="documents-edit"
  //   path="documents/edit/:id"
  //   element={
  //     <ProtectedRoute
  //       element={<AddDocument parentPath={parentPath} />}
  //       codes={permissionsDeveloper}
  //     />
  //   }
  // />,

  <Route
    key="climate1"
    path="climate1"
    element={
      <ProtectedRoute element={<Carbon1 />} codes={permissionsDeveloper} />
    }
  />,
  <Route
    key="climate2"
    path="climate2"
    element={
      <ProtectedRoute element={<Carbon2 />} codes={permissionsDeveloper} />
    }
  />,
  <Route
    key="climate3"
    path="climate3"
    element={
      <ProtectedRoute element={<Carbon3 />} codes={permissionsDeveloper} />
    }
  />,
  <Route
    key="climate4"
    path="climate4"
    element={
      <ProtectedRoute element={<Carbon4 />} codes={permissionsDeveloper} />
    }
  />,
  <Route path="partners/:partnerId">
    {partnerRoutes(parentPath, { showLocations: true })}
  </Route>,
  <Route path="companies/:customerId">
    {companyRoutes(parentPath, {
      showLocations: true,
      showAddCompany: true,
      showEditCompany: true,
    })}
  </Route>,
  <Route path="tenants/:tenantId">
    {tenantRoutes(parentPath, { showLocations: true })}
  </Route>,
  <Route path="roles">{roleRoutes(parentPath)}</Route>,
  <Route path="subscriptions">{subscriptionRoutes(parentPath)}</Route>,
];
